import * as React from 'react'
import { LegacyRef, forwardRef, memo } from 'react'
import Svg, { G, Path } from 'react-native-svg'
import type { LogoProps } from './LogoProps'

const LogoLight = (props: LogoProps, ref: LegacyRef<Svg>) => {
  const WIDTH = 246
  const HEIGHT = 56
  const OFFSET = 8

  const vbMinX = 0
  const vbMinY = props.balance ? -OFFSET : 0
  const vbWidth = WIDTH
  const vbHeight = props.balance ? HEIGHT + OFFSET : HEIGHT
  return (
    <Svg
      width={WIDTH}
      height={HEIGHT}
      viewBox={`${vbMinX} ${vbMinY} ${vbWidth} ${vbHeight}`}
      preserveAspectRatio="xMinYMid meet"
      ref={ref}
      {...props}
    >
      <G fillRule="nonzero" fill="none">
        <Path
          d="m228.542 12.03 6.077 14.933 6.119-14.933h5.143L232.36 44.489h-5.04l4.708-11.677-8.628-20.782h5.143Zm-154.228-.477c5.89 0 10.827 4.521 10.827 11.386 0 6.948-4.957 11.345-10.827 11.345-2.945 0-5.932-1.161-7.28-3.588v13.73h-4.812V12.03h4.812v3.214c1.348-2.343 4.335-3.691 7.28-3.691Zm67.802 0c5.89 0 10.826 4.521 10.826 11.386 0 6.948-4.957 11.345-10.826 11.345-2.946 0-5.932-1.161-7.28-3.588v13.73h-4.812V12.03h4.812v3.214c1.348-2.343 4.334-3.691 7.28-3.691Zm-48.886.477v12.133c0 3.588 1.908 5.455 4.521 5.455 2.8 0 5.6-1.535 5.6-5.89V12.03h4.812v21.798h-4.812v-3.173c-1.265 2.468-4.21 3.65-6.492 3.65-5.237 0-8.391-3.283-8.442-9.26V12.03h4.813Zm73.63-.477c6.2 0 11.448 4.397 11.448 11.303 0 6.907-5.227 11.45-11.449 11.45-6.16 0-11.345-4.543-11.345-11.45 0-6.906 5.185-11.303 11.345-11.303Zm22.233 0c3.879 0 7.654 1.783 7.944 6.45h-4.584c-.186-1.639-1.68-2.344-3.173-2.344-1.224 0-2.613.477-3.09 1.224-.374.601-.415 1.307-.187 1.97.29.85 1.493 1.348 2.655 1.68l3.36.85c4.708 1.162 5.703 4.149 5.703 6.347 0 4.21-3.691 6.575-8.69 6.575-4.065 0-8.255-2.572-8.358-7.135h4.438c.228 1.867 1.784 3.132 4.293 3.132 2.199 0 3.879-.975 3.879-2.613 0-1.41-1.452-2.199-3.028-2.572l-2.945-.705c-4.626-1.265-6.306-3.609-6.015-7.114.29-3.215 3.775-5.745 7.798-5.745Zm-65.52.02c1.535 0 3.174.374 3.879.85l-.788 4.44a7.016 7.016 0 0 0-3.215-.747c-4.107 0-5.828 4.106-5.828 9.893v7.82h-4.833v-21.8h4.812v5c1.12-3.88 3.277-5.456 5.973-5.456Zm82.735.457v21.798h-4.77V12.03h4.77Zm11.864-8.276v8.276h4.625v3.961h-4.625v17.837h-4.812V15.991h-3.92V12.03h3.92V3.754h4.812ZM73.712 16.22c-3.546 0-6.636 2.572-6.636 6.824 0 4.293 3.318 6.637 6.637 6.637 3.65 0 6.533-2.613 6.533-6.637 0-4.065-2.904-6.824-6.533-6.824Zm67.781 0c-3.546 0-6.637 2.572-6.637 6.824.021 4.293 3.34 6.637 6.637 6.637 3.65 0 6.534-2.613 6.534-6.637 0-4.065-2.904-6.824-6.534-6.824Zm25.366.062c-3.588 0-6.575 2.572-6.575 6.575 0 4.107 2.987 6.762 6.575 6.762 3.65.02 6.637-2.655 6.637-6.762 0-4.023-2.986-6.575-6.637-6.575ZM203.923.166c1.784 0 3.173 1.307 3.173 3.028 0 1.722-1.41 3.028-3.173 3.028-1.722 0-3.215-1.306-3.215-3.028 0-1.721 1.493-3.028 3.215-3.028ZM28.27 33.227H0V.954C0 .477.394.062.892.062H28.29c9.147 0 16.572 7.425 16.572 16.572 0 9.167-7.425 16.593-16.592 16.593Z"
          fill="#31C5F4"
        />
        <Path
          d="M0 54.921c0 .892 1.161 1.224 1.639.457L13.087 36.67.021 33.87V54.92H0Z"
          fill="#1485A8"
        />
        <Path fill="#0F7190" d="M0 33.227v.643l13.087 2.8 2.095-3.443z" />
      </G>
    </Svg>
  )
}

const ForwardRef = forwardRef(LogoLight)
const Memo = memo(ForwardRef)
export default Memo
